import React from 'react';
import namrata from '../../../assets/client logos/namrata.svg';
import jugni from '../../../assets/client logos/jugniandcc.svg';
import digitaltokari from '../../../assets/client logos/digitaltokri.svg';
import theclub from '../../../assets/client logos/theclub.svg';
import palate from '../../../assets/client logos/palate.svg';
import mpl from '../../../assets/client logos/mpl.svg';
import nifd from '../../../assets/client logos/nifd.svg';
import setuequal from '../../../assets/client logos/setuequal.svg';
import data from '../../../assets/client logos/data.svg';
import ranka from '../../../assets/client logos/ranka.svg';
import federalbank from '../../../assets/client logos/federalbank.svg';
import socks from '../../../assets/client logos/socks.svg';
import chique from '../../../assets/client logos/chique.svg';
import puraniks from '../../../assets/client logos/puraniks.svg';
import aromas from '../../../assets/client logos/aromas.svg';
import mandke from '../../../assets/client logos/mandke.svg';
import square from '../../../assets/client logos/square.svg';
import "../../../css/client-logo.css";

function ClientLogoSection() {

    return (
        <div className="client-logo-container">
            <div className="logos">
                <div className="logos-slide-reverse">
                    <img className='h-20 xl:h-24 logo' src={data} alt="logo1" />
                    <img className='h-20 xl:h-24 logo' src={ranka} alt="logo2" />
                    <img className='h-20 xl:h-24 logo' src={federalbank} alt="logo3" />
                    <img className='h-20 xl:h-24 logo' src={socks} alt="logo4" />
                    <img className='h-20 xl:h-24 logo' src={chique} alt="logo5" />
                    <img className='h-20 xl:h-24 logo' src={puraniks} alt="logo6" />
                    <img className='h-20 xl:h-24 logo' src={aromas} alt="logo7" />
                    <img className='h-20 xl:h-24 logo' src={mandke} alt="logo8" />
                    <img className='h-20 xl:h-24 logo' src={square} alt="logo9" />
                    <img className='h-20 xl:h-24 logo' src={data} alt="logo1" />
                    <img className='h-20 xl:h-24 logo' src={ranka} alt="logo2" />
                    <img className='h-20 xl:h-24 logo' src={federalbank} alt="logo3" />
                    <img className='h-20 xl:h-24 logo' src={socks} alt="logo4" />
                    <img className='h-20 xl:h-24 logo' src={chique} alt="logo5" />
                    <img className='h-20 xl:h-24 logo' src={puraniks} alt="logo6" />
                    <img className='h-20 xl:h-24 logo' src={aromas} alt="logo7" />
                    <img className='h-20 xl:h-24 logo' src={mandke} alt="logo8" />
                    <img className='h-20 xl:h-24 logo' src={square} alt="logo9" />
                    <img className='h-20 xl:h-24 logo' src={data} alt="logo1" />
                    <img className='h-20 xl:h-24 logo' src={ranka} alt="logo2" />
                    <img className='h-20 xl:h-24 logo' src={federalbank} alt="logo3" />
                    <img className='h-20 xl:h-24 logo' src={socks} alt="logo4" />
                    <img className='h-20 xl:h-24 logo' src={chique} alt="logo5" />
                    <img className='h-20 xl:h-24 logo' src={puraniks} alt="logo6" />
                    <img className='h-20 xl:h-24 logo' src={aromas} alt="logo7" />
                    <img className='h-20 xl:h-24 logo' src={mandke} alt="logo8" />
                    <img className='h-20 xl:h-24 logo' src={square} alt="logo9" />
                    <img className='h-20 xl:h-24 logo' src={data} alt="logo1" />
                    <img className='h-20 xl:h-24 logo' src={ranka} alt="logo2" />
                    <img className='h-20 xl:h-24 logo' src={federalbank} alt="logo3" />
                    <img className='h-20 xl:h-24 logo' src={socks} alt="logo4" />
                    <img className='h-20 xl:h-24 logo' src={chique} alt="logo5" />
                    <img className='h-20 xl:h-24 logo' src={puraniks} alt="logo6" />
                    <img className='h-20 xl:h-24 logo' src={aromas} alt="logo7" />
                    <img className='h-20 xl:h-24 logo' src={mandke} alt="logo8" />
                    <img className='h-20 xl:h-24 logo' src={square} alt="logo9" />
                </div>
                <div className="logos-slide-reverse">
                    <img className='h-20 xl:h-24 logo' src={data} alt="logo1" />
                    <img className='h-20 xl:h-24 logo' src={ranka} alt="logo2" />
                    <img className='h-20 xl:h-24 logo' src={federalbank} alt="logo3" />
                    <img className='h-20 xl:h-24 logo' src={socks} alt="logo4" />
                    <img className='h-20 xl:h-24 logo' src={chique} alt="logo5" />
                    <img className='h-20 xl:h-24 logo' src={puraniks} alt="logo6" />
                    <img className='h-20 xl:h-24 logo' src={aromas} alt="logo7" />
                    <img className='h-20 xl:h-24 logo' src={mandke} alt="logo8" />
                    <img className='h-20 xl:h-24 logo' src={square} alt="logo9" />
                    <img className='h-20 xl:h-24 logo' src={data} alt="logo1" />
                    <img className='h-20 xl:h-24 logo' src={ranka} alt="logo2" />
                    <img className='h-20 xl:h-24 logo' src={federalbank} alt="logo3" />
                    <img className='h-20 xl:h-24 logo' src={socks} alt="logo4" />
                    <img className='h-20 xl:h-24 logo' src={chique} alt="logo5" />
                    <img className='h-20 xl:h-24 logo' src={puraniks} alt="logo6" />
                    <img className='h-20 xl:h-24 logo' src={aromas} alt="logo7" />
                    <img className='h-20 xl:h-24 logo' src={mandke} alt="logo8" />
                    <img className='h-20 xl:h-24 logo' src={square} alt="logo9" />
                    <img className='h-20 xl:h-24 logo' src={data} alt="logo1" />
                    <img className='h-20 xl:h-24 logo' src={ranka} alt="logo2" />
                    <img className='h-20 xl:h-24 logo' src={federalbank} alt="logo3" />
                    <img className='h-20 xl:h-24 logo' src={socks} alt="logo4" />
                    <img className='h-20 xl:h-24 logo' src={chique} alt="logo5" />
                    <img className='h-20 xl:h-24 logo' src={puraniks} alt="logo6" />
                    <img className='h-20 xl:h-24 logo' src={aromas} alt="logo7" />
                    <img className='h-20 xl:h-24 logo' src={mandke} alt="logo8" />
                    <img className='h-20 xl:h-24 logo' src={square} alt="logo9" />
                    <img className='h-20 xl:h-24 logo' src={data} alt="logo1" />
                    <img className='h-20 xl:h-24 logo' src={ranka} alt="logo2" />
                    <img className='h-20 xl:h-24 logo' src={federalbank} alt="logo3" />
                    <img className='h-20 xl:h-24 logo' src={socks} alt="logo4" />
                    <img className='h-20 xl:h-24 logo' src={chique} alt="logo5" />
                    <img className='h-20 xl:h-24 logo' src={puraniks} alt="logo6" />
                    <img className='h-20 xl:h-24 logo' src={aromas} alt="logo7" />
                    <img className='h-20 xl:h-24 logo' src={mandke} alt="logo8" />
                    <img className='h-20 xl:h-24 logo' src={square} alt="logo9" />
                </div>

            </div>
            <div className="logos">
                <div className="logos-slide">
                    <img className="h-20 xl:h-24 logo" src={namrata} alt="logo1" />
                    <img className="h-20 xl:h-24 logo" src={jugni} alt="logo2" />
                    <img className="h-20 xl:h-24 logo" src={digitaltokari} alt="logo3" />
                    <img className="h-20 xl:h-24 logo" src={theclub} alt="logo4" />
                    <img className="h-20 xl:h-24 logo" src={palate} alt="logo5" />
                    <img className="h-20 xl:h-24 logo" src={mpl} alt="logo6" />
                    <img className="h-20 xl:h-24 logo" src={nifd} alt="logo7" />
                    <img className="h-20 xl:h-24 logo" src={setuequal} alt="logo8" />
                    <img className="h-20 xl:h-24 logo" src={namrata} alt="logo1" />
                    <img className="h-20 xl:h-24 logo" src={jugni} alt="logo2" />
                    <img className="h-20 xl:h-24 logo" src={digitaltokari} alt="logo3" />
                    <img className="h-20 xl:h-24 logo" src={theclub} alt="logo4" />
                    <img className="h-20 xl:h-24 logo" src={palate} alt="logo5" />
                    <img className="h-20 xl:h-24 logo" src={mpl} alt="logo6" />
                    <img className="h-20 xl:h-24 logo" src={nifd} alt="logo7" />
                    <img className="h-20 xl:h-24 logo" src={setuequal} alt="logo8" />
                    <img className="h-20 xl:h-24 logo" src={namrata} alt="logo1" />
                    <img className="h-20 xl:h-24 logo" src={jugni} alt="logo2" />
                    <img className="h-20 xl:h-24 logo" src={digitaltokari} alt="logo3" />
                    <img className="h-20 xl:h-24 logo" src={theclub} alt="logo4" />
                    <img className="h-20 xl:h-24 logo" src={palate} alt="logo5" />
                    <img className="h-20 xl:h-24 logo" src={mpl} alt="logo6" />
                    <img className="h-20 xl:h-24 logo" src={nifd} alt="logo7" />
                    <img className="h-20 xl:h-24 logo" src={setuequal} alt="logo8" />
                    <img className="h-20 xl:h-24 logo" src={namrata} alt="logo1" />
                    <img className="h-20 xl:h-24 logo" src={jugni} alt="logo2" />
                    <img className="h-20 xl:h-24 logo" src={digitaltokari} alt="logo3" />
                    <img className="h-20 xl:h-24 logo" src={theclub} alt="logo4" />
                    <img className="h-20 xl:h-24 logo" src={palate} alt="logo5" />
                    <img className="h-20 xl:h-24 logo" src={mpl} alt="logo6" />
                    <img className="h-20 xl:h-24 logo" src={nifd} alt="logo7" />
                    <img className="h-20 xl:h-24 logo" src={setuequal} alt="logo8" />
                </div>
                <div className="logos-slide">
                    <img className="h-20 xl:h-24 logo" src={namrata} alt="logo1" />
                    <img className="h-20 xl:h-24 logo" src={jugni} alt="logo2" />
                    <img className="h-20 xl:h-24 logo" src={digitaltokari} alt="logo3" />
                    <img className="h-20 xl:h-24 logo" src={theclub} alt="logo4" />
                    <img className="h-20 xl:h-24 logo" src={palate} alt="logo5" />
                    <img className="h-20 xl:h-24 logo" src={mpl} alt="logo6" />
                    <img className="h-20 xl:h-24 logo" src={nifd} alt="logo7" />
                    <img className="h-20 xl:h-24 logo" src={setuequal} alt="logo8" />
                    <img className="h-20 xl:h-24 logo" src={namrata} alt="logo1" />
                    <img className="h-20 xl:h-24 logo" src={jugni} alt="logo2" />
                    <img className="h-20 xl:h-24 logo" src={digitaltokari} alt="logo3" />
                    <img className="h-20 xl:h-24 logo" src={theclub} alt="logo4" />
                    <img className="h-20 xl:h-24 logo" src={palate} alt="logo5" />
                    <img className="h-20 xl:h-24 logo" src={mpl} alt="logo6" />
                    <img className="h-20 xl:h-24 logo" src={nifd} alt="logo7" />
                    <img className="h-20 xl:h-24 logo" src={setuequal} alt="logo8" />
                    <img className="h-20 xl:h-24 logo" src={namrata} alt="logo1" />
                    <img className="h-20 xl:h-24 logo" src={jugni} alt="logo2" />
                    <img className="h-20 xl:h-24 logo" src={digitaltokari} alt="logo3" />
                    <img className="h-20 xl:h-24 logo" src={theclub} alt="logo4" />
                    <img className="h-20 xl:h-24 logo" src={palate} alt="logo5" />
                    <img className="h-20 xl:h-24 logo" src={mpl} alt="logo6" />
                    <img className="h-20 xl:h-24 logo" src={nifd} alt="logo7" />
                    <img className="h-20 xl:h-24 logo" src={setuequal} alt="logo8" />
                    <img className="h-20 xl:h-24 logo" src={namrata} alt="logo1" />
                    <img className="h-20 xl:h-24 logo" src={jugni} alt="logo2" />
                    <img className="h-20 xl:h-24 logo" src={digitaltokari} alt="logo3" />
                    <img className="h-20 xl:h-24 logo" src={theclub} alt="logo4" />
                    <img className="h-20 xl:h-24 logo" src={palate} alt="logo5" />
                    <img className="h-20 xl:h-24 logo" src={mpl} alt="logo6" />
                    <img className="h-20 xl:h-24 logo" src={nifd} alt="logo7" />
                    <img className="h-20 xl:h-24 logo" src={setuequal} alt="logo8" />
                </div>
            </div>

        </div>
    )
}

export default ClientLogoSection;
